import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';

const ErrorBoundaryWrapper = (props) => {
    const {
        children,
        paddingOverride,
        marginOverride,
        width,
        componentStack,
        componentName,
        showButton,
        buttonText,
        horizontal,
        onReset,
        customMessage,
        customDictKey,
        isButtonDisabled,
        buttonShape,
        buttonStyle,
        ...ErrorFallbackProps
    } = props;

    const errorHandler = useCallback((error) => {
        console.error(componentName, error);
    }, [componentName, ErrorFallbackProps]);

    const resetHandler = useCallback(() => {
        onReset();
    }, [onReset]);

    return (
        <ErrorBoundary
            fallbackRender={ErrorFallbackProps =>
                <ErrorFallback
                    {...ErrorFallbackProps}
                    componentName={componentName}
                    paddingOverride={paddingOverride}
                    marginOverride={marginOverride}
                    horizontal={horizontal}
                    width={width}
                    showButton={showButton}
                    buttonText={buttonText}
                    componentStack={componentStack}
                    customMessage={customMessage}
                    customDictKey={customDictKey}
                    isButtonDisabled={isButtonDisabled}
                    buttonShape={buttonShape}
                    buttonStyle={buttonStyle}
                />}
            onError = {errorHandler}
            onReset = {resetHandler}
        >
            { children }
        </ErrorBoundary>
    );
};

ErrorBoundaryWrapper.propTypes = {
    children: PropTypes.any,
    showButton: PropTypes.bool,
    buttonText: PropTypes.string,
    resetErrorBoundary: PropTypes.func,
    componentName: PropTypes.string,
    error: PropTypes.any,
    componentStack: PropTypes.any,
    paddingOverride: PropTypes.string,
    marginOverride: PropTypes.string,
    horizontal: PropTypes.bool,
    width: PropTypes.number,
    onReset: PropTypes.func,
    customMessage: PropTypes.string,
    customDictKey: PropTypes.string,
    isButtonDisabled: PropTypes.bool
};

export default ErrorBoundaryWrapper;
